import { createFileRoute } from '@tanstack/react-router';

import { Reports } from '@/view/pages/Reports';

export const Route = createFileRoute('/_protected/$programId/relatorios')({
  component: Reports,
  context: (context): { title: string } => ({
    ...context,
    title: 'Relatórios',
  }),
});
